export const REPORT_SELECT_PLACEHOLDER = "Reports";

// #region TEST IDs
export const REPORT_SELECTOR_TEST_ID = "report-selector";
export const REPORTS_SELECT_ALL_ENDUR_REPORTS_TEST_ID = "all_endur_reports";
export const REPORTS_SELECT_OPTION_TEST_ID = "all-reports-item";
export const REPORTS_SELECT_ALL_NUCLEUS_REPORTS_TEST_ID = "all_nucleus_reports";
// #endregion
